import { render, staticRenderFns } from "./RestrictedAccess.vue?vue&type=template&id=6a239e6b&"
import script from "./RestrictedAccess.vue?vue&type=script&lang=js&"
export * from "./RestrictedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports